import { Box, Tooltip, useClipboard } from '@chakra-ui/react';
import CopyIcon from '@root/assets/admin/icons/copyIcon';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CopyFeature = ({ text }: any) => {
    const { t } = useTranslation("common");
    const [tooltipLabel, setTooltipLabel] = useState(t('translate.copyToClipboard'));
    const { onCopy } = useClipboard(text || 'null');

    const handleCopyClick = () => {
        onCopy();
        setTooltipLabel(t('translate.copiedToClipboard'));
        setTimeout(() => setTooltipLabel(t('translate.copyToClipboard')), 2000); // Reset after 2 seconds
    };

    return (
        <Tooltip label={tooltipLabel} hasArrow>
            <Box>
                <CopyIcon
                    onClick={handleCopyClick}
                />
            </Box>
        </Tooltip>
    );
};

export default CopyFeature;
